import APIService from '../../../services/api.service';
import { MATERIAL_GRADE_ID_PATTERN } from '../types/material-grade.constants';
import { useQuery } from 'react-query';

export interface SuggestedMaterialGradesResponse {
   materialPartTexts: string[];
}

export const useMaterialGradeSuggestions = (materialGradeId: string | undefined) => {
   const isValidId = !!materialGradeId && MATERIAL_GRADE_ID_PATTERN.test(materialGradeId);

   const { data, isLoading, error } = useQuery(
      ['suggestedMaterialGrades', materialGradeId],
      () => APIService.getSuggestedMaterialGrades(materialGradeId!),
      {
         enabled: isValidId,
         staleTime: 5 * 60 * 1000, // Cache for 5 minutes
         retry: 1,
      }
   );

   return {
      suggestions: data?.materialPartTexts || [],
      isLoading,
      error,
      hasValidId: isValidId,
   };
};
